import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

export const wrapper: TRuleWithTheme = () => ({
    max768: {
        position: 'relative',
    },

    min768: {
        display: 'flex',
        alignItems: 'center',

        flexDirection: 'row',
    },
});

export const button: TRuleWithTheme = () => ({
    max768: {
        position: 'absolute',
        top: '4.75rem',
        right: 0,
    },

    min768: {
        position: 'relative',
        top: '-0.75rem',

        marginLeft: '2.5rem',
    },
});

export const textInput: TRuleWithTheme = () => ({
    position: 'relative',
    zIndex: 2,

    '& .ant-input-suffix': {
        paddingRight: '0 !important',
    },

    '&.ant-input-affix-wrapper:hover': {
        zIndex: 2,
    },

    min768: {
        flex: 1,

        '& svg': {
            cursor: 'pointer',
        },
    },
});
export const cryptedTextInput: TRuleWithTheme = combineRules(textInput, (({ theme }) => ({
    '&.ant-input-affix-wrapper > .ant-input': {
        ...theme.typography.Password,
        lineHeight: '1rem',
    },
})) as TRuleWithTheme);

export const formItem: TRuleWithTheme = () => ({
    '&.ant-form-item': {
        marginBottom: 0,
    },

    min768: {
        '&.ant-form-item': {
            marginBottom: 0,
        },
    },
});

export const container: TRuleWithTheme = () => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',

    overflow: 'visible',

    max768: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },

    min768: {
        display: 'flex',
        flex: '1 1 0%',
    },
});
